/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Webinars = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="10 10 30 30">
      <path
        d="M36.57,14H13.43a3,3,0,0,0-3,3V33a3,3,0,0,0,3,3H36.57a3,3,0,0,0,3-3V17A3,3,0,0,0,36.57,14ZM19,34V32a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v2Zm3-10a3,3,0,1,1,3,3A3,3,0,0,1,22,24Zm15.57,9a1,1,0,0,1-1,1H33V32a5,5,0,0,0-4.1-4.88,5,5,0,1,0-7.8,0A5,5,0,0,0,17,32v2H13.43a1,1,0,0,1-1-1V17a1,1,0,0,1,1-1H36.57a1,1,0,0,1,1,1Z"
        id="icon/wellness/webinars"
      />
    </BaseSvgIcon>
  )
}

export default Webinars
